export default __webpack_public_path__ + "static/media/information--parking--g4.09eab1e8.png";